









































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import SaveButton from '@/components/App/SaveButton.vue';
import { Cutoverplan, Environment } from '@/types';
import env from '../env';

@Component({
  components: { SaveButton }
})
export default class EnvironmentsView extends Vue {
  dialog = false;

  get all_cutoverplans() {
    return this.$store.state.all_cutoverplans;
  }

  new_name = '';

  environments: Environment[] = [];

  cutoverplans: Cutoverplan[] = [];

  new_environment_name = '';

  selected_environment: Environment | {} = {};

  envs_by_cutoverplan: Record<string, Environment[]> = {};

  swatches = [
    ['#E8B291', '#C6D7F9'],
    ['#87C8B3', '#E7D3AE']
  ];

  @Watch('environments')
  async onEnvironmentsChanged() {
    this.envs_by_cutoverplan = await this.groupByCop();
  }

  async groupByCop() {
    const envs_by_cop: Record<number, Environment[]> = {};
    for (const environment of this.environments) {
      if (!envs_by_cop[environment.id]) envs_by_cop[environment.id] = [];
      envs_by_cop[environment.id].push(environment);
    }
    return envs_by_cop;
  }

  goToNewEnv() {
    const newEnv = document.getElementById('newEnv');
    if (newEnv) this.$vuetify.goTo(newEnv);
  }

  async addEnv() {
    const response = await axios.post(`${env.backend_url}/environment/create`, {
      name: this.new_environment_name
    });
    this.new_environment_name = '';
    this.environments.push(response.data);
    return response;
  }

  async refreshData() {
    const { data: environments } = await axios.get(`${env.backend_url}/all_environments`);
    this.environments = environments;
    const { data: cutoverplans } = await axios.get(`${env.backend_url}/all_cutoverplans`);
    this.cutoverplans = cutoverplans;
  }

  async created() {
    this.$emit('showPreloader');
    await this.refreshData();
    await this.$store.dispatch('refreshAllEnvironments');
    this.$emit('loadingFinished');
  }

  saveEnvironments() {
    const promises: Promise<AxiosResponse>[] = [];
    this.environments.forEach((environment) =>
      promises.push(
        axios.post(`${env.backend_url}/environment/update/${environment.id}`, environment)
      )
    );
    return Promise.all(promises);
  }
}
